export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PATH_LOOKUP = "lookup";
export const PATH_DASHBOARD = "manage/dashboard";
export const PATH_PRODUCT = "product";

export const PATH_CATEGORY = "category";

export const PATH_ORDER = "order";
export const PATH_EXPENSE = "lottery";
export const PATH_ORGANISER = "organiser";
export const PATH_CMS = "cms";
export const PATH_EMPLOYEE = "employee";
export const PATH_CUSTOMER = "customer";
export const PATH_CAR = "car";
export const PATH_BRANCH = "branch";
export const PATH_STORE = "users/store";
export const PATH_TESTDRIVE = "testdrive";
export const PATH_SALE = "sale";
export const PATH_USERS = "employees";
export const PATH_TRANSACTIONS = "transaction";
export const PATH_EMAIL_GROUP = "emailgroup";

export const PATH_CAT = "manage/category";
export const PATH_UNIT = "manage/unit";

export const PATH_VENDOR = "manage/vendor";
// export const PATH_CMS = "cms";
export const PATH_FORM = "form_builder";
export const PATH_CONFIGURATION = "configuration";
export const PATH_COUPON = "coupon";
export const PATH_FEATURE = "features";

export const PATH_SUBCAT = "manage/subcategory";
export const PATH_LOWCAT = "manage/lowcategory";
export const PATH_ETSY_SYNC = "sync/etsy";
export const PATH_ETSY_GOLD_SYNC = "sync/etsy_gold";

export const PATH_SHOPIFY_SYNC = "sync/shopify";
export const PATH_SHOPIFY_TJ_SYNC = "sync/shopify_tj";

export const PATH_AUTH = "auth/admin/login";
export const PATH_AUTH_REFRESH = "auth/admin/refresh";

export const PATH_BANNER = "api/banner";

export const PATH_MANAGE = "manage/";

export const PATH_API_MANAGE = "api/";
